/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Session_ExpiredInputs */



/**
* | output |
* | --- |
* | "Your session expired. Please sign in again." |
*
* @param {Auth_Session_ExpiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_session_expired = /** @type {((inputs?: Auth_Session_ExpiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_ExpiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.")
	return /** @type {LocalizedString} */ ("Your session expired. Please sign in again.")
});